import React, { useState } from "react";
import {
  Button,
  Fade,
  Paper,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import TrapFocus from "@mui/material/Unstable_TrapFocus";
import { useTranslation } from "react-i18next";

export const CookieBanner: React.FC = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("sm"));
  const [bannerOpen, setBannerOpen] = useState(true);

  const closeBanner = () => {
    setBannerOpen(false);
  };

  const acceptCookies = () => {
    localStorage.setItem("cookiesAccepted", "true");
    closeBanner();
  };

  const rejectCookies = () => {
    localStorage.setItem("cookiesAccepted", "false");
    closeBanner();
  };

  if (localStorage.getItem("cookiesAccepted")) {
    return null;
  }

  return (
    <TrapFocus open disableAutoFocus disableEnforceFocus>
      <Fade appear={false} in={bannerOpen}>
        {/*
          Kept small and tucked into the corner (rather than the previous
          500x238 card) so that while it's open it covers as little of the
          page as possible. A fixed-position overlay of any size will always
          sit in front of whatever page content happens to scroll underneath
          it - a large card was routinely covering part of the trusted-by
          logo marquee lower on the page, silently swallowing the hover
          events react-fast-marquee's pauseOnHover needs, which is what made
          the strip look like it was randomly "resetting" instead of
          pausing. Shrinking the footprint shrinks that overlap window.
        */}
        <Paper
          role="dialog"
          aria-modal="false"
          aria-label="Cookie banner"
          square
          variant="outlined"
          tabIndex={-1}
          sx={{
            width: isSmall ? "auto" : 320,
            position: "fixed",
            bottom: 10,
            left: isSmall ? 10 : "auto",
            right: 10,
            padding: 1.5,
            border: 2,
            borderColor: "secondary.main",
            borderRadius: 2,
            zIndex: 9,
          }}
        >
          <Stack direction="column" justifyContent="flex-start" gap={1}>
            <Typography variant="subtitle1" color="textSecondary">
              {t("cookie.title")}
            </Typography>

            <Typography variant="caption" color="textSecondary">
              {t("cookie.body")}
            </Typography>

            <Stack direction="row" gap={1} justifyContent="flex-end">
              <Button size="small" onClick={rejectCookies} variant="outlined">
                {t("cookie.reject")}
              </Button>
              <Button size="small" onClick={acceptCookies} variant="contained">
                {t("cookie.accept")}
              </Button>
            </Stack>
          </Stack>
        </Paper>
      </Fade>
    </TrapFocus>
  );
};
